import { useState, useCallback, useEffect } from 'react';
import { inventoryService } from '../services/inventory.service';

export function useInventory() {
    const [inventory, setInventory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchInventory = useCallback(async (force = false) => {
        setLoading(true);
        setError(null);
        try {
            const data = await inventoryService.getInventory(force);
            setInventory(data);
        } catch (err) {
            console.error(err);
            setError(err.message || 'Error loading inventory');
        } finally {
            setLoading(false);
        }
    }, []);

    const clearInventoryCache = useCallback(() => {
        inventoryService.clearCache();
        setInventory([]);
    }, []);

    // Initial fetch optional or controlled by component?
    // Let's allow manual trigger to avoid blocking render

    return {
        inventory,
        loading,
        error,
        fetchInventory,
        clearInventoryCache
    };
}
